import { useState, useEffect } from 'react'
import isEmpty from 'lodash/isEmpty'
import { useDispatch } from 'react-redux'
import { getTireAvailabilityStatus } from 'components/common/TireAvailability/actions'
import { createRequestPayloadForInventoryService } from 'components/common/TireAvailability/helpers'
import { setSkusAddedToCart } from 'components/common/hoc/withAddToQuote/actions.js'

const useTireAvailabilityStatus = (params) => {
  const [availability, setAvailability] = useState({})
  const dispatch = useDispatch()
  const {
    contextType = '',
    quantityUpdated = '',
    countFront,
    countRear,
    brandName,
    frontTireBvId,
    rearTireBvId,
    storeNumber,
    dependencies = [],
    productSkuId,
    isPilotStore,
    activeVehicleId
  } = params

  const commonProperties = {
    partNumber: frontTireBvId,
    sourceOfDelivery: 'LOCAL',
    sourceType: 'LOCAL',
    wareHouseId: storeNumber,
    qty: countFront,
    brand: brandName.toUpperCase(),
    activeVehicleId
  }

  // Temporary check added to stop inventory api from being called for each product added on cart component unmounting
  if (contextType === 'quote' && !window.location.pathname?.includes('/quote')) return null

  useEffect(() => {
    if ((contextType !== 'plp' || quantityUpdated) && storeNumber && isPilotStore) {
      dispatch(getTireAvailabilityStatus(
        createRequestPayloadForInventoryService(
          countFront,
          countRear,
          brandName,
          frontTireBvId,
          rearTireBvId,
          storeNumber),
        productSkuId
      )).then(response => {
        if (!isEmpty(response) && response.data) {
          const { itemDetails } = response.data
          const length = itemDetails?.length
          // This if condition is added to check out of stock status for staggered fitment
          // If any of the front/rear is out of stock then the length will be 1 otherwise it will be 2
          if (frontTireBvId && rearTireBvId && length !== 2) {
            setAvailability({})
          } else if (length) {
            // In case of staggered fitment as well both front and rear will have the same availability status
            setAvailability(itemDetails[0])
            if (contextType === 'quote') {
              const { qty, brand } = commonProperties
              dispatch(setSkusAddedToCart({
                ...itemDetails[0],
                qty,
                brand,
                activeVehicleId
              }))
            }
          } else {
            setAvailability({})
            if (contextType === 'quote') {
              dispatch(setSkusAddedToCart(commonProperties))
            }
          }
        } else {
          setAvailability({})
          if (contextType === 'quote') {
            dispatch(setSkusAddedToCart(commonProperties))
          }
        }
      }).catch(error => {
        setAvailability({})
        if (contextType === 'quote') {
          dispatch(setSkusAddedToCart(commonProperties))
        }
      })
    }
  }, [...dependencies])

  return [availability, setAvailability]
}

export default useTireAvailabilityStatus
